import * as React from "react";
import type { SVGProps } from "react";
const SvgLanguage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#language_svg__a)">
      <path d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10m0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8" />
      <path d="M12 22c-3.11 0-4.79-5.15-4.79-10S8.89 2 12 2s4.79 5.15 4.79 10S15.11 22 12 22m0-18c-1.14 0-2.79 3.12-2.79 8s1.65 8 2.79 8 2.79-3.12 2.79-8S13.14 4 12 4" />
      <path d="M21 13H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1M12 9c-1 0-4.46-.12-7.27-1.7a1 1 0 0 1 .98-1.74C7.6 6.62 10.2 7 12 7s4.4-.38 6.29-1.44a1 1 0 0 1 .98 1.74C16.47 8.88 13 9 12 9M18.78 18.57c-.17 0-.33-.04-.49-.13C16.4 17.38 13.8 17 12 17s-4.4.38-6.29 1.44a1 1 0 0 1-.98-1.74C7.53 15.12 11 15 12 15s4.46.12 7.27 1.7a1 1 0 0 1 .38 1.36c-.18.33-.52.51-.87.51" />
    </g>
    <defs>
      <clipPath id="language_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLanguage;
